// File: CreateEditDialog.tsx

import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
} from "@mui/material";

interface CreateEditDialogProps {
  open: boolean;
  type: "workspace" | "department" | "position" | "userposition" | "project";
  mode: "create" | "edit"; // ✅ Add this
  name: string;
  description?: string;
   setName: (value: string) => void; // ✅ now matches your simple update handler
  setDescription?: React.Dispatch<React.SetStateAction<string>>;
  onClose: () => void;
  onSave: () => void;
   parentId?: number; // ✅ New optional prop
}

const CreateEditDialog: React.FC<CreateEditDialogProps> = ({
  open,
  onClose,
  type,
  name,
  mode,
  description,
  setName,
  setDescription,
  onSave,
}) => {
  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>Create {type}</DialogTitle>
      <DialogContent sx={{ pt: 2 }}>
        <TextField
          label={`${type.charAt(0).toUpperCase() + type.slice(1)} Name`}
          fullWidth
          value={name}
          onChange={(e) => setName(e.target.value)}
          sx={{ mb: type === "workspace" ? 2 : 0 }}
          margin="dense"
        />
        {type === "workspace" && setDescription && (
          <TextField
            label="Description (optional)"
            fullWidth
            value={description || ""}
            onChange={(e) => setDescription(e.target.value)}
            margin="dense"
          />
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>

        <Button onClick={onSave} variant="contained" color="primary">
          {mode === "edit" ? "Update" : "Create"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default CreateEditDialog;
